import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      // Availability must stay current while staff are on the phone with a guest.
      refetchInterval: 60_000,
      retry: (count, e) => {
        if (e instanceof ApiError && (e.status === 401 || e.status === 403 || e.status === 404 || e.status === 422)) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});
